import {tagSelectAll} from '../../components/tag-select-all'

const init = () => {
    tagSelectAll()
}

export default init
